import type { PaginationConfig } from '@/types/shared';

export const buildPaginationParams = (
  paginationConfig: PaginationConfig | undefined,
  overridePageNumber?: number,
) => {
  return {
    size: paginationConfig?.perPage,
    number: overridePageNumber ?? paginationConfig?.page ?? 1,
  };
};
